import { Box, Stack, Text } from "@chakra-ui/react"
import { type AttemptTimerRecord, formatClock } from "./studentTimer"

interface StudentTimerReviewSummaryProps {
  record: AttemptTimerRecord | null
}

/** The student's own pacing results; renders nothing if no timer was used. */
export function StudentTimerReviewSummary({
  record,
}: StudentTimerReviewSummaryProps) {
  const lines: string[] = []

  const wholeTest = record?.wholeTest
  if (wholeTest?.elapsedSeconds !== undefined) {
    const used = formatClock(wholeTest.elapsedSeconds)
    const target = formatClock(wholeTest.limitSeconds)
    const overtime = wholeTest.elapsedSeconds - wholeTest.limitSeconds
    lines.push(
      overtime > 0
        ? `Your whole-test timer: ${used} used, ${formatClock(
            overtime,
          )} over your ${target} target.`
        : `Your whole-test timer: ${used} used of your ${target} target.`,
    )
  }

  const overQuestions = Object.keys(record?.questionOvertime ?? {}).length
  if (overQuestions > 0) {
    lines.push(
      `${overQuestions} ${
        overQuestions === 1 ? "question went" : "questions went"
      } over your per-question target.`,
    )
  }

  if (lines.length === 0) return null

  return (
    <Box
      borderWidth="1px"
      borderColor="border"
      borderRadius="md"
      bg="bg.subtle"
      p={4}
    >
      <Stack gap={1}>
        <Text fontWeight="semibold">Your pacing</Text>
        {lines.map((line) => (
          <Text key={line} fontSize="sm" color="fg.muted">
            {line}
          </Text>
        ))}
      </Stack>
    </Box>
  )
}
